"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setServerTimeDelta", {
  enumerable: true,
  get: function get() {
    return _setServerTimeDelta["default"];
  }
});
var _setServerTimeDelta = _interopRequireDefault(require("./setServerTimeDelta"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }